export const APP_UPDATE_FLAG = 'app-update-wall';

export const STORE_URLS = {
	ios: 'https://apps.apple.com/app/id6758960307',
	android: 'https://play.google.com/store/apps/details?id=com.heru.herumobileapp',
} as const;

export const UNKNOWN_APP_VERSION = 'unknown';

export const FORCED_THRESHOLD = 'forced';
